import React from "react";
import Modal from "react-bootstrap/Modal";

const DepartmentModal = ({
  show,
  onClose,
  departmentName,
  setDepartmentName,
  groupData,
  group,
  setGroup,
  error,
  handleSubmit,
  disableSubmit,
}) => {
  return (
    <Modal show={show} onHide={onClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Add Department</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Department Name */}
        <div className="input-block local-forms">
          <label>
            Name <span className="login-danger">*</span>
          </label>
          <input
            className="form-control"
            type="text"
            value={departmentName}
            onChange={(e) => setDepartmentName(e.target.value)}
            placeholder="Enter name"
          />
          {error?.name && (
            <p className="text-danger mt-1 mb-0 small">{error.name}</p>
          )}
        </div>

        {/* Department Group Dropdown */}
        <div className="input-block local-forms mt-3">
          <label>
            Group <span className="login-danger">*</span>
          </label>
          <select
            className="form-select"
            value={group}
            onChange={(e) => setGroup(e.target.value)}
          >
            <option value="">Select Group</option>
            {groupData?.map((grp) => (
              <option key={grp._id} value={grp._id}>
                {grp.name}
              </option>
            ))}
          </select>
        {error?.group && <p className="text-danger mt-1 mb-0 small">{error.group}</p>}
        </div>

      </Modal.Body>

      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          Cancel
        </button>

        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSubmit}
          disabled={disableSubmit}
        >
          {disableSubmit ? "Saving..." : "Save"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default DepartmentModal;
